module.exports = __webpack_public_path__ + "img/Icon-Rankings.4cd9301c.svg";